import React from "react";
import moment from "moment";
import {useNavigate} from "react-router-dom";
import {Autocomplete, Box, Container, Fab, FormControl, InputLabel, List, ListItem, MenuItem, Select, TextField} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SlideDatepicker from "./partial/SlideDatepicker";
import EditSchedules from "./partial/EditSchedules";
import EditScheduleStepper from "./partial/EditScheduleStepper";
import {getJgList, getRiyoDaySearch, getRiyoList, getServiceList} from "../api/client";
import {initial, kanaList} from "../locales/locale";

export default function EditSchedule(props) {
  const loadParams = (nm) => {
    return sessionStorage.getItem(nm) || "";
  };
  const saveParams = (nm, val) => {
    return sessionStorage.setItem(nm, val);
  };
  const loadJson = (nm) => {
    return JSON.parse(sessionStorage.getItem(nm)) || [];
  };
  const saveJson = (nm, val) => {
    return sessionStorage.setItem(nm, JSON.stringify(val));
  };
  const navigate = useNavigate();
  const [state, setState] = React.useState({
    date: loadParams("editScheduleDate") || moment().format("yyyy-MM-DD"),
    edit: Boolean(loadParams("edit")),
    jgCd: loadParams("jgCd") || "",
    riyoNo: loadParams("riyoNo") || "",
    riyoList: [],
    data: true
  });
  const errorFunc = (error) => {
    if (Boolean(error.response && error.response.data && error.response.data.message)) {
      navigate("/", {state: error.response.data.message});
    } else if (Boolean(error.response && error.response.data && error.response.data.errors)) {
      props.setToastState({...props.toastState, message: error.response.data.errors, error: true});
    } else {
      props.setToastState({...props.toastState, message: null, error: true, networkError: true});
    };
  };
  async function changeDate() {
    let jg = {data: loadJson("jgList")};
    let defaultJg = state.jgCd;
    if (!Boolean(jg.data.length)) {
      jg = await getJgList().catch(error => errorFunc(error));
      let mainJg = jg.data.find(j => j[2] === "1");
      defaultJg = jg.data.length === 1 ? jg.data[0][0] : Boolean(mainJg) ? mainJg[0] : "";
      saveJson("jgList", jg.data);
      saveParams("jgCd", defaultJg);
    };
    const riyo = Boolean(loadParams("jgCd")) ? await getRiyoList({ymdDt: state.date, bsJg: loadParams("jgCd")}).catch(error => errorFunc(error)) : {data: []};
    const riyoList = riyo.data.map(r => [...r, initial[kanaList.findIndex(kanaL => kanaL.includes(r[2].substr(0, 1)))] || initial[10]]);
    const defaultRiyo = Boolean(riyoList.find(r => r[0] === state.riyoNo)) ? state.riyoNo : "";
    const data = Boolean(defaultRiyo) ? await getRiyoDaySearch({ymdDt: state.date, bsJg: loadParams("jgCd"), riyoNo: defaultRiyo}).catch(error => errorFunc(error)) : {data: []};
    setState({...state, jgCd: defaultJg, riyoNo: defaultRiyo, riyoList: riyoList});
    saveJson("data", data.data);
    saveParams("editScheduleDate", state.date);
    saveParams("riyoNo", defaultRiyo);
  };
  async function changeJg(val) {
    const riyo = Boolean(val) ? await getRiyoList({ymdDt: state.date, bsJg: val}).catch(error => errorFunc(error)) : {data: []};
    const riyoList = riyo.data.map(r => [...r, initial[kanaList.findIndex(kanaL => kanaL.includes(r[2].substr(0, 1)))] || initial[10]]);
    const defaultRiyo = riyoList.length === 1 ? riyoList[0][0] : "";
    const data = Boolean(defaultRiyo) ? await getRiyoDaySearch({ymdDt: state.date, bsJg: val, riyoNo: defaultRiyo}).catch(error => errorFunc(error)) : {data: []};
    setState({...state, jgCd: val, riyoNo: defaultRiyo, riyoList: riyoList});
    saveJson("data", data.data);
    saveParams("jgCd", val);
    saveParams("riyoNo", defaultRiyo);
  };
  async function changeRiyo(val) {
    const data = await getRiyoDaySearch({ymdDt: state.date, bsJg: state.jgCd, riyoNo: val}).catch(error => errorFunc(error));
    setState({...state, riyoNo: val});
    saveJson("data", data.data);
    saveParams("riyoNo", val);
  };
  async function edit() {
    const svsObj = await getServiceList({ymdDt: state.date, bsJg: state.jgCd, riyoNo: state.riyoNo}).catch(error => errorFunc(error));
    if (Boolean(svsObj)) {
      const sjIdx = svsObj.data.findIndex(([svsCd]) => ["98", "97"].includes(svsCd));
      let svsList = [...svsObj.data];
      if (sjIdx !== -1) {
        const sjSvsList = [...svsObj.data[sjIdx][2]].map((sjSvs) => [svsObj.data[sjIdx][0] + "_" + sjSvs[0], sjSvs[1]]);
        svsList.splice(sjIdx, 1, ...sjSvsList);
      };
      setState({...state, edit: true});
      saveJson("svsList", svsList);
      saveParams("edit", "1");
    };
  };

  React.useEffect(() => {
    changeDate();
    if (!(state.edit)) {
      sessionStorage.removeItem("editScheduleStepper");
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.date]);

  return (
    <Container
      maxWidth = "sm"
      sx = {{p: 2, pt: 0, flexGrow: 1}}
    >
      <Box
        className = "bgcolor-white"
        position = "sticky"
        sx = {{top: 55, pt: 2, textAlign: "center", zIndex: 1}}
      >
        <SlideDatepicker
          disabled = {state.edit}
          setState = {setState}
          state = {state}
          ymdFg = {true}
        />
        <List>
          <ListItem>
            <FormControl
              size = "small"
              sx = {{width: "100%"}}
            >
              <InputLabel
                id = "stff_list_label"
                sx = {{zindex: 2}}
              >
                事業所
              </InputLabel>
              <Select
                autoWidth
                disabled = {state.edit}
                id = "jg_list"
                label = "事業所"
                labelId = "jg_list_label"
                MenuProps = {{PaperProps: {style: {maxHeight: 200}}}}
                onChange = {(e) => changeJg(e.target.value)}
                value = {state.jgCd}
              >
                {loadJson("jgList").map((jg) => (
                  <MenuItem
                    key = {"jg" + jg[0]}
                    value = {jg[0]}
                  >
                    {jg[1]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </ListItem>
          <ListItem>
            <Autocomplete
              clearIcon = {false}
              value = {state.riyoList.find((riyo) => riyo[0] === state.riyoNo) || []}
              disabled = {state.edit}
              fullWidth
              getOptionLabel = {(option) => Boolean(option[1]) ? option[1] + " (" + option[2] + ")" : ""}
              groupBy = {(option) => option[3]}
              key = {state.jgCd} // 事業所変更時リセットするため設定
              noOptionsText = "データはありません。"
              onChange = {(e, val) => Boolean(val) ? changeRiyo(val[0]) : setState({...state, riyoNo: "", data: []})}
              options = {state.riyoList}
              renderInput = {(params) => <TextField {...params} label = "利用者" size = "small" />}
            />
          </ListItem>
        </List>
      </Box>
      {state.edit &&
        <EditScheduleStepper
          errorFunc = {errorFunc}
          setState = {setState}
          setToastState = {props.setToastState}
          state = {state}
          toastState = {props.toastState}
        />
      }
      {!(state.edit) && Boolean(state.riyoNo) &&
        <>
        <EditSchedules
          errorFunc = {errorFunc}
          setToastState = {props.setToastState}
          toastState = {props.toastState}
        />
        <Fab
          className = "btn-submit"
          onClick = {() => edit()}
          sx = {{boxShadow: "0px 4px 12px -2px gray!important", position: "absolute", bottom: 20, right: 20}}
        >
          <AddIcon />
        </Fab>
        </>
      }
    </Container>
  );
};
